<template>
    <div class="stuckdart" v-if="stuck">
        <div class="stuckdartMain">
            <h1>Achtung: Dart steckt fest</h1>
        </div>
    </div>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            stuck: false,
        }
    },
    mounted() {
        window.connection.subscribeSensor(this);
        this.update(window.connection.lastSensorUpdate);
    },
    methods: {
        update(data) {
            if (data == null) return;
            this.stuck = data.stuckdart;
        },
    }
}
</script>

<style scoped>
    .stuckdart {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgb(245 152 2 / 58%);
        z-index: 1000;
        justify-content: center;
        align-items: center;
    }

    .stuckdartMain h1 {
        font-size: 5vw;
        text-align: center;
        background-color: white;
        padding: 2vw;
        margin-top: -10vh;
        box-shadow: 0 20px 50px #111;
        animation: blinker 2s linear infinite;
    }
    @keyframes blinker {
        25% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
    }

</style>
